<template>
    <div>
        <div class="row mb-lg-6 mb-0" v-if="exam">
            <div class="col-12 col-lg-2 course-logo-link-div">
                <router-link class="course-logo-link" :to="`/exam/${exam.idexam}`">
                    <img
                            class="exam-logo"
                            v-if="exam.logo"
                            :src="exam.logo"
                    >

                    <img
                            class="exam-logo"
                            src="@/assets/hometeacher/images/exam-logo.png"
                            v-else
                    >
                </router-link>
            </div>

            <div class="col-12 col-lg-7 home-kurs mt-lg-0 mt-3">
                <div class="row">
                    <div class="col-12">
                        <div class="exam-name pb-2">
                            <img v-if="exam.difficulty" class="easy"
                                 :src="require(`@/assets/hometeacher/images/${difficlty}.png`)">
                            <router-link :to="`/exam/${exam.idexam}`">
                                {{exam.exam}}
                            </router-link>
                        </div>
                    </div>
                    <div class="col-12">
                        <p v-if="exam.idlanguage">{{ $t('Language') }}: <span class="strong-black">{{ languageText }}</span></p>
                        <p v-if="exam.ages">{{ $t('Age') }}: <span class="strong-black">{{ ageText }}</span></p>
                        <p v-if="exam.duration">{{ $t('Duration') }}: <span
                                class="strong-black">{{ course.duration }}</span></p>
                    </div>
                    <div class="col-12 kurs kurs-under" v-if="exam.description">
                        {{stripHtml(exam.description)}}
                    </div>
                    <div class="col-12 col-lg-5 kurs" v-else>
                        {{ $t('empty_description') }}
                    </div>
                </div>
            </div>

            <div class="col-12 col-lg-2 zapis mt-lg-0 mt-3">
                <div class="row">
                    <div class="col-12">
                        <base-button @click="view" class="ma-0">{{ $t('pass_test') }}</base-button>
                    </div>
                    <div class="col-12 mt-2">{{ $t('free') }}</div>
                </div>
            </div>

            <div class="col-12 d-lg-none" v-if="!lastItem">
                <div class="land-t-delimeter mx-4"></div>
            </div>
        </div>
    </div>


</template>

<script>
    import courseApi from "../data/CourseApi";

    export default {
        name: "ExamListItem",
        props: {
            title: String,
            exam: {
                type: Object,
            },
            lastItem: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            ageText() {
                if (this.exam.ages && this.exam.ages.length > 0) {
                    let ages = []
                    for (let age of this.exam.ages) {
                        ages.push(courseApi.getAgeName(age.idage))
                    }
                    return ages.join(", ")
                }
                return courseApi.getAllAgeNames();
            },

            languageText() {
                if (this.exam.idlanguage) return courseApi.getLanguageName(this.exam.idlanguage)
                return "-";
            },

            difficlty() {
                if (this.exam.difficulty) return courseApi.getDifficultyName(this.exam.difficulty).toLowerCase()
                return "easy";
            },
        },

        methods: {
            view() {
                this.$router.push('/exam/' + this.exam.idexam)
            },

            stripHtml(html) {
                // Create a new div element
                var temporalDivElement = document.createElement("div");
                // Set the HTML content with the providen
                temporalDivElement.innerHTML = html;
                // Retrieve the text property of the element (cross-browser support)
                return temporalDivElement.textContent || temporalDivElement.innerText || "";
            }
        }
    }
</script>

<style scoped>
    .exam-logo {
        border: 1px solid #d7e1e5;
        border-radius: 6px;
        height: 144px;
        width: 160px;
        object-fit: cover;
    }

    .h2kurs {
        cursor: pointer;
    }

    .exam-name a {
        font-family: "Manrope Bold";
        font-size: 30px;
        color: #ed1c24;
        border-bottom: 1px solid #ed1c24;
    }

    .course-logo-link {
        display: inline-block;
    }

    .course-logo-link-div {
        text-align: center;
    }

    @media (max-width: 580px) {
        .easy {
            margin: 0 auto;
        }
    }
</style>

<style src="@/assets/hometeacher/css/main.css">
</style>
